module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAAPFBMVEUAAAD////////////////////////////////////////////////////////////////////////////YSWgTAAAAE3RSTlMABBgjJDs8QENEn6Orr8PL3+/z25Xs+AAAAKVJREFUOMuVk0kOwyAQBBsbsE0Aw/D/v4YkUsQ+cl2nxNoN7JbSBLI7IKfjryJh0xILWguExFAL0Rvj41Rwh0BGXG4oBI0/OvSC31Cw3a0Qqnk2QiNoNOhacOhwlXD0wlUKUfSCoELwGOALwYwEwwmvJ1uwh2SvyT9UUu1cPf0s9rvzGsUuKowjd/4id7ppaOkTWlqkehR7tjhs9dbljTLXe1V/iTcokjIB4PvUlgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dpg-w.png
// module id = W4Z0
// module chunks = 1